export default {
	youtubeThumbUrl: function(videoID){
		return 'https://i1.ytimg.com/vi/' + videoID + '/hqdefault.jpg'
	},
	youtubeEmbedIframeUrl: function(videoID){
		return 'https://www.youtube-nocookie.com/embed/' + videoID + '?rel=0&amp;showinfo=0'
	}
}


// WEBPACK FOOTER //
// ./src/lib/youtubeLinks.js